import { useAudio } from "@aircall/tractor";
import { useEffect } from "react";

export function usePlayerShortcut() {
  const { togglePlay, fastForward, rewind } = useAudio();
  useEffect(() => {
    const handleKeydown = (event: KeyboardEvent) => {
      // make sure the active element is body, not an input field for example
      if (event.target === document.body) {
        switch (event.key) {
          case " ":
            togglePlay();
            break;
          case "ArrowLeft":
            rewind();
            break;
          case "ArrowRight":
            fastForward();
            break;
          default:
            return;
        }
      }
    };
    document.addEventListener("keydown", handleKeydown);
    return () => {
      document.removeEventListener("keydown", handleKeydown);
    };
  }, []);
}
